import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Route Components
import ImageConverter from './pages/ImageConverter';
import TagUpdater from './pages/TagUpdater';
import PasswordGate from './PasswordGate';
import FlavorUpdater from './pages/FlavorUpdater';
import FlavorProfileUpdater from './pages/FlavorProfileUpdater';
import StagedProductReview from './pages/StagedProductReview';
import KnowledgeBase from './pages/KnowledgeBase';
import KnowledgeBaseArticle from './pages/KnowledgeBaseArticle';
import KnowledgeBaseEditor from './pages/KnowledgeBaseEditor';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/flavor-updater",
    element: <FlavorUpdater />,
  },
  {
    path: "/flavor-profile-updater",
    element: <FlavorProfileUpdater />,
  },
  {
    path: "/image-converter",
    element: <ImageConverter />,
  },
  {
    path: "/tag-updater",
    element: <TagUpdater />,
  },
  {
    path: "/products/review",
    element: <StagedProductReview />,
  },
  {
    path: "/knowledge-base",
    element: <KnowledgeBase />,
  },
  {
    path: "/knowledge-base/new",
    element: <KnowledgeBaseEditor />,
  },
  {
    path: "/knowledge-base/:slug/edit",
    element: <KnowledgeBaseEditor />,
  },
  {
    path: "/knowledge-base/:slug",
    element: <KnowledgeBaseArticle />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PasswordGate>
      <RouterProvider router={router} />
    </PasswordGate>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
